const PropTypes = require('prop-types');

export const TableColumnVisibility = PropTypes.shape({
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  show: PropTypes.bool,
  showable: PropTypes.bool,
});
